import React, { useState, useCallback } from 'react'
import { BasicCard, Icon } from './components'
import InfoCard from './info'
import FormCard from './form'

const Security: React.FC<unknown> = () => {
  const [edit, setEdit] = useState<boolean>(false)

  const changeEditState = useCallback(
    (editState: boolean) => () => {
      setEdit(editState)
    },
    []
  )

  return (
    <BasicCard view={edit ? 'form' : 'info'}>
      <Icon sx={{ margin: '0 2%', alignSelf: 'flex-start', width: '100px' }} />
      {edit ? (
        <FormCard onClose={changeEditState(false)} />
      ) : (
        <InfoCard onClick={changeEditState(true)} />
      )}
    </BasicCard>
  )
}

export default Security
